export default __webpack_public_path__ + "static/media/governmentIconoff.f56af8c0.svg";